import { NodeSelection, TextSelection } from '@atlaskit/editor-prosemirror/state';
import { CellSelection } from '@atlaskit/editor-tables/cell-selection';
import { fg } from '@atlaskit/platform-feature-flags';

import type {
	ReplaceNodeCommand,
	StreamingCommandFactory,
} from '../aiStreamingOrchestratorPluginType';

import { findNodeByLocalId } from './utils/find-node-by-local-id';

export const createReplaceNodeCommand: StreamingCommandFactory<ReplaceNodeCommand> =
	(api) => (command) => {
		api.core.actions.execute(({ tr }) => {
			findNodeByLocalId(api, tr, command.localId, ({ pos, node }) => {
				let selection = null;
				// this if block can be removed when 'platform_editor_ai_aifc_patch_ga' is removed
				// i.e. we will not want any special handling for table replacements
				if (node.type.name === 'table' && !fg('platform_editor_ai_aifc_patch_ga')) {
					tr.replaceRangeWith(
						pos,
						pos + node.nodeSize,
						tr.doc.type.schema.nodes.paragraph.create(),
					);
					selection = TextSelection.create(tr.doc, pos + 1);
				} else if (NodeSelection.isSelectable(node)) {
					selection = NodeSelection.create(tr.doc, pos);
				} else {
					const role = node.type.spec.tableRole;
					if (role === 'cell' || role === 'header_cell') {
						selection = CellSelection.create(tr.doc, pos);
					} else if (role === 'row') {
						// There's always a cell after the row
						const $cell = tr.doc.resolve(pos + 1);
						selection = CellSelection.rowSelection($cell, $cell, true);
					} else {
						const $pos = tr.doc.resolve(pos);
						const $end = tr.doc.resolve(pos + node.nodeSize);
						selection = TextSelection.between($pos, $end);
					}
				}
				if (selection) {
					tr.setSelection(selection).scrollIntoView();
				}
			});
			return tr;
		});
		return true;
	};
